import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import defult from './defult.jpg';
import { useStateContext } from '../../Contexts/ContextProvider';

const AddSponser = () => {
  const [uploading , setIsUploading] = useState(false) ; 
  const { SetNotification } = useStateContext();
  const nameRef = useRef(null);
  const descriptionRef = useRef(null);
  const logoRef = useRef(null);
  const websiteRef = useRef(null);
  const typeRef = useRef(null);
  const [image_, setImage] = useState(defult);
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const navigate = useNavigate();
  const {id}= useParams () ; 

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);

    const reader = new FileReader();

    reader.onload = (event) => {
      setImagePreviewUrl(event.target.result);
    };

    reader.readAsDataURL(selectedImage);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading (true) ; 
    const formData = new FormData();
    formData.append('name', nameRef.current.value);
    formData.append('description', descriptionRef.current.value);
    formData.append('logo', image_);
    formData.append('conference_id', id);
    
    formData.append('website', websiteRef.current.value);
    formData.append('type', typeRef.current.value);
    formData.append('active', 1 ); 

    try {
      await AxiosClient.post('/sponsors', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      SetNotification('Sponsor added successfully', 'success');
      navigate(-1);
    } catch (error) {
      setIsUploading(false); 

      if (error.response && error.response.data && error.response.data.message) {
        SetNotification(error.response.data.message, 'danger');
      } else {
        SetNotification('An error occurred while adding sponsor.', 'danger');
        setIsUploading(false); 
      }
    }
  };

  return (
    <div className="m-4">
      <form className="form-group">
        <h5>  Name</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter name" ref={nameRef} />
        </div>
      

        <h5>Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" placeholder="Enter description" rows={5} ref={descriptionRef} />
        </div>

        <h5>Logo</h5>
        <div className="w-full flex flex-wrap items-center">
          <label htmlFor="imageUpload" className="w-full block mb-2 font-medium text-gray-700 m-2">
            Sponsor Logo:
          </label>
          <input
            type="file"
            id="imageUpload"
            accept="image/*"
            onChange={handleImageChange}
            className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <img
          src={imagePreviewUrl ? imagePreviewUrl : defult}
          alt="Uploaded"
          style={{ maxWidth: '250px', maxHeight: '25%' }}
          className="w-full object-contain mb-w-100 text-center"
        />

        <h5>Website</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter website" ref={websiteRef} />
        </div>

        <h5>Type</h5>
        <div className="input-group input-group-outline mb-3">
          <select  className="form-control p-1" ref={typeRef} >
           <option  className="m-2"value={"Platinum"} > 
           Platinum
           </option>
           <option value={"Golden"} > 
           Golden
           </option>
           <option value={"Silver"} > 
           Silver
           </option>
            </select>


          
        </div>

      
    { uploading? (<h4 className='text-red' > loading </h4> ) 
    : 
        <button onClick={handleSubmit} className="btn btn-primary mt-3">
          Submit
        </button>}
      </form>
    </div>
  );
};

export default AddSponser;
